module.exports = __webpack_public_path__ + "6c4817dac66410326cf504c9d87634fb.svg";